export const getGoogleMapsDirectionLink = (directionFrom, directionTo) =>
  `https://www.google.com/maps?saddr=${directionFrom.latitude},${directionFrom.longitude}&daddr=${directionTo.latitude},${directionTo.longitude}`;

export const handleRedirectToGoogleMaps = (startLocation = '', destination) => {
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
    startLocation
  )}&destination=${destination.latitude},${destination.longitude}`;
  window.open(googleMapsUrl, '_blank');
};
